"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _HeadlineLayout = require("./HeadlineLayout");
Object.keys(_HeadlineLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _HeadlineLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _HeadlineLayout[key];
        }
    });
});
